import {Container} from '@mui/material';
import useDocumentTitle from '../../utils/useDocumentTitle';
import { HeaderArea } from '../../components/pageHeader';

const Census = () => {
  useDocumentTitle('Youth Work One - Census');
  setTimeout(() => {
    window.location.href = 'https://survey.alchemer.eu/s3/91060040/6a6bb117e6ca';
  }, 5000);
  return (
    <Container maxWidth="xl" disableGutters={true} sx={{ mt: '10px' }}>
      <HeaderArea title="Youth Work One - Census">The Youth Work One Census has now moved</HeaderArea>
      You are now being redirected to our Census provider website. If you are
      not automatically redirected, please click the following link:{' '}
      <a
        href="https://survey.alchemer.eu/s3/91060040/6a6bb117e6ca"
        target="_blank"
        rel="noreferrer"
      >
        https://survey.alchemer.eu/s3/91060040/6a6bb117e6ca
      </a>
    </Container>

  );
}

export default Census;